import * as React from 'react';

import { ResultsEmpty, trackSearchOffersButtonClick, trackSignInButtonClick } from '../../components/ResultsEmpty';
import { useSelector } from 'react-redux';
import { selectResults } from '../../selectors/results';
import { selectFilters } from '../../selectors/filters';
import { selectUser } from '../../selectors/user';
import { selectPage } from '../../selectors/page';
import { ResultsEmptyFolder } from '../../components/ResultsEmpty/ResultsEmptyFolder';
import { selectSelectedFolder } from '../../selectors/folders';
import { getSearchUrl } from '../../utils/filters';

export function ResultsEmptyContainer() {
  const user = useSelector(selectUser);
  const results = useSelector(selectResults);
  const filters = useSelector(selectFilters);
  const page = useSelector(selectPage);
  const selectedFolder = useSelector(selectSelectedFolder);

  const { favoriteEntities } = results;
  const { deviceType } = page;
  const { isAuthenticated } = user;

  const handleClickSearch = () => {
    if (isAuthenticated) {
      trackSearchOffersButtonClick();
      window.location.assign(selectedFolder ? '/' : getSearchUrl(filters));
    } else {
      trackSignInButtonClick();
      if (window.hasOwnProperty('waitForLoginPopup')) {
        window.waitForLoginPopup();
      }
    }
  };

  if (selectedFolder) {
    return (
      <ResultsEmptyFolder isAuthenticated={isAuthenticated} onClickSearch={handleClickSearch} deviceType={deviceType} />
    );
  }

  return (
    <ResultsEmpty
      user={user}
      filters={filters}
      favoriteEntitiesLength={favoriteEntities.length}
      deviceType={deviceType}
    />
  );
}
